import { isDetailScope, isPluginScope } from '../helpers';
import { AppStructureBuilderError } from './error';
export function addReadout({ readoutName, scopeName, viewName, entityName }) {
    this.updateAppStructure(draftBuilder => {
        if (!draftBuilder.application.readouts[readoutName] && !entityName) {
            throw new AppStructureBuilderError(`Entity name not found for readout ${readoutName}. You must provide the entity name when creating a readout without a scope.`);
        }
        draftBuilder.application.readouts[readoutName] = draftBuilder.application.readouts[readoutName] ?? this.newReadout({ readoutName, entityName: entityName });
        if (scopeName && viewName) {
            const view = draftBuilder.getView(viewName);
            const scope = view?.scopes[scopeName];
            if (!view) {
                throw new AppStructureBuilderError(`View ${viewName} not found`);
            }
            if (!scope) {
                throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
            }
            if (isPluginScope(scope)) {
                throw new AppStructureBuilderError(`Scope ${scopeName} is a plugin scope and cannot have details`);
            }
            if (!isDetailScope(scope)) {
                throw new AppStructureBuilderError(`Scope ${scopeName} is not a detail scope`);
            }
            scope.readouts = scope.readouts || [];
            if (!scope.readouts.includes(readoutName)) {
                scope.readouts.push(readoutName);
            }
        }
    });
    return this;
}
export function removeReadout(detailName) {
    this.updateAppStructure(draftBuilder => {
        const scopes = draftBuilder.getScopesByReadoutName(detailName);
        for (const scope of scopes) {
            if (scope.readouts) {
                scope.readouts = scope.readouts.filter(it => it !== detailName);
            }
        }
        delete draftBuilder.application.readouts[detailName];
    });
    return this;
}
export function removeReadoutFromScope({ readoutName, scopeName, viewName }) {
    this.updateAppStructure(draftBuilder => {
        const view = draftBuilder.getView(viewName);
        const scope = view?.scopes[scopeName];
        if (!view) {
            throw new AppStructureBuilderError(`View ${viewName} not found`);
        }
        if (!scope) {
            throw new AppStructureBuilderError(`Scope ${scopeName} not found in view ${viewName}`);
        }
        if (isPluginScope(scope)) {
            throw new AppStructureBuilderError(`Scope ${scopeName} is a plugin scope and cannot have readouts`);
        }
        if (!isDetailScope(scope)) {
            throw new AppStructureBuilderError(`Scope ${scopeName} is not a detail scope`);
        }
        if (scope.readouts) {
            scope.readouts = scope.readouts.filter(it => it !== readoutName);
        }
    });
    return this;
}
export function addReadoutField({ readoutFieldName, readoutName, readoutType, }) {
    this.updateAppStructure(draftBuilder => {
        const readout = draftBuilder.getReadout(readoutName);
        if (!readout) {
            throw new AppStructureBuilderError(`Readout ${readoutName} not found. You must create the readout before adding fields.`);
        }
        draftBuilder.application.readouts[readoutName] = draftBuilder.application.readouts[readoutName] ?? readout;
        if (!readout.entityName) {
            throw new AppStructureBuilderError(`Entity name not found for form ${readoutName}. You must add the form to a scope before adding fields.`);
        }
        const detailField = readout.fields[readoutFieldName];
        const modelField = draftBuilder.getEntityField(readout.entityName, readoutFieldName);
        const numberOfFields = detailField?.order ? detailField.order : Object.keys(readout.fields).length;
        readout.fields[readoutFieldName] = draftBuilder.newDefaultDetailField({ fieldName: readoutFieldName, numberOfFields, modelField });
    });
    return this;
}
export function removeReadoutField({ readoutFieldName, readoutName }) {
    this.updateAppStructure(draftBuilder => {
        const detail = draftBuilder.getReadout(readoutName);
        if (!detail) {
            throw new AppStructureBuilderError(`Readout ${readoutName} not found`);
        }
        if (!detail.fields[readoutFieldName]) {
            throw new AppStructureBuilderError(`Field ${readoutFieldName} not found in readout ${readoutName}`);
        }
        delete detail.fields[readoutFieldName];
    });
    return this;
}
//# sourceMappingURL=readoutManagement.js.map